export default __webpack_public_path__ + "coupon-set-codes-bulk.63bb897a477fce90a91f4fc9a9e4a05e.svg";